import { isEqual } from 'lodash'

import { complex, core } from '@/components/services/settings/smpp/ipWhitelist/mixins'

import render from './render'

export default {
  name: 'ipWhitelist',

  mixins: [ core, complex ],

  props: {
    loading: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      showDialog: false
    }
  },

  computed: {
    disabled() {
      if (this.loading.update) {
        return true
      }

      return isEqual(this.proxy, this._inputFilter(this.value))
    }
  },

  methods: {
    emit(value) {
      if (!this.disabled) {
        this.$emit('input', value)
      }
    }
  },

  render
}
